import isomorphicCookie from 'isomorphic-cookie'
import { decode, encode } from 'jwt-simple'

const setCookie = (label, value, options) => {
  if (document) {
    const { secure, domain, expiresIn, sameSite } = options
    let optionsString = ''
    if (expiresIn) optionsString = optionsString + `;expires=${expiresIn}`
    if (secure) optionsString = optionsString + `;secure=${secure}`
    if (domain) optionsString = optionsString + `;domain=${domain}`
    if (sameSite) optionsString = optionsString + `;samesite=${sameSite}`

    document.cookie = `${label}=${value}` + optionsString + ';path=/'
  }
}

const getMainDomain = () => {
  if (process.env.REACT_APP_ALLOWED_DOMAINS) {
    const { mainDomain } = JSON.parse(process.env.REACT_APP_ALLOWED_DOMAINS)
    return mainDomain
  }
  return undefined
}

export const getCredentials = searchString => {
  if (searchString) {
    let params = new URLSearchParams(searchString)
    return {
      redirectUri: params.get('redirectUri'),
      clientId: params.get('clientId'),
      responseType: params.get('responseType'),
    }
  }
  return {}
}

export const getRedirectUri = searchString => {
  if (searchString) {
    let params = new URLSearchParams(searchString)
    return params.get('redirectUri')
  }
  return null
}

export const getResponseType = searchString => {
  if (searchString) {
    let params = new URLSearchParams(searchString)
    return params.get('responseType')
  }
  return null
}

export const getClientId = searchString => {
  if (searchString) {
    let params = new URLSearchParams(searchString)
    return params.get('clientId')
  }
  return null
}

export const encodeSSOData = data => {
  const clientSecret = process.env.REACT_APP_JWT_SECRET || 'xxxx'
  const payload = encode(data, clientSecret)
  return payload
}

export const decodeSSOData = data => {
  if (data) {
    const clientSecret = process.env.REACT_APP_JWT_SECRET || 'xxxx'
    const payload = decode(data, clientSecret)
    return payload
  } else return {}
}

export const getSSOToken = async () => {
  const accessToken = await isomorphicCookie.load('token', {
    secure: process.env.NODE_ENV === 'production',
    domain: getMainDomain(),
  })
  return accessToken
}

export const saveSSOData = async token => {
  if (process.env.REACT_APP_ALLOWED_DOMAINS) {
    await setCookie('token', token, {
      domain: getMainDomain(),
      secure: process.env.NODE_ENV === 'production',
    })
  }
}

export const getSSOData = async () => {
  const token = await getSSOToken()
  return token ? await decodeSSOData(token) : null
}

export const setSSOVerification = async verified => {
  if (typeof window !== 'undefined') {
    await sessionStorage.setItem('sso_verified', verified)
  }
}

export const deleteSSOVerification = async () => {
  if (typeof window !== 'undefined') {
    const ssoVerified = (await sessionStorage.getItem('sso_verified')) || false
    if (ssoVerified) {
      await sessionStorage.removeItem('sso_verified')
    }
  }
}

export const isClientVerified = async () => {
  let ssoVerified = false
  if (typeof window !== 'undefined')
    ssoVerified = await sessionStorage.getItem('sso_verified')

  if (ssoVerified === true || ssoVerified === 'true') return true
  return false
}

export const deleteSSOData = async () => {
  await isomorphicCookie.remove('token', {
    secure: process.env.NODE_ENV === 'production',
    domain: getMainDomain(),
    path: '/',
  })
  await deleteSSOVerification()
}
